import { getCookie, removeCookie, setCookie } from './cookie';
import { servicesInfo } from '../data/cookie';
import { BASKET_COOKIE_EXPIRED } from '../data/consts';
import { ServiceCookie, Service } from '../types/services';

export const isSameService = (service1: ServiceCookie, service2: ServiceCookie): boolean => {
  return (
    service1.code === service2.code &&
    service1.parentCode === service2.parentCode &&
    service1.configuratorId === service2.configuratorId
  );
};

export const isServiceExist = (service: ServiceCookie): boolean => {
  const services = getServicesCookie();

  if (!services) return false;

  return services.some(s => isSameService(s, service));
};

export const transformServiceToCookie = (services: ServiceCookie[]) => {
  return services.map(service => {
    const { code, parentCode, ...rest } = service;

    return {
      ...rest,
      id: code,
      parentLineId: parentCode,
    };
  });
};

export const transformServiceFromCookie = (services: Service[]) => {
  return services.map(service => {
    const { id, parentLineId, ...rest } = service;

    return {
      ...rest,
      code: id,
      ...(parentLineId && { parentCode: parentLineId }),
    };
  });
};

export const saveServicesArrayToCookie = (services: ServiceCookie[]) => {
  if (services.length > 0) {
    const cookieStr = JSON.stringify(transformServiceToCookie(services));

    setCookie(servicesInfo, cookieStr, { expires: BASKET_COOKIE_EXPIRED });
  } else {
    removeCookie(servicesInfo);
  }
};

export const getServicesCookie = (): ServiceCookie[] | undefined => {
  const cookie = getCookie(servicesInfo);

  if (!cookie) return;

  return transformServiceFromCookie(JSON.parse(cookie));
};

export const addServiceCookie = (service: ServiceCookie): ServiceCookie[] | undefined => {
  const services = getServicesCookie();

  const result = services ? [...services, service] : [service];

  saveServicesArrayToCookie(result);

  return result;
};

export const updateServiceCookie = (service: ServiceCookie): ServiceCookie[] | undefined => {
  const services = getServicesCookie();

  if (!services) return;

  const result = services.map(s => (isSameService(s, service) ? service : s));

  saveServicesArrayToCookie(result);

  return result;
};

export const deleteServiceCookie = (service: ServiceCookie): ServiceCookie[] | undefined => {
  const services = getServicesCookie();

  if (!services) return;

  const result = services.filter(s => !isSameService(s, service));

  saveServicesArrayToCookie(result);

  return result;
};
